// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shortcut-section-item__keys[data-v-905b80e8]{display:flex;gap:var(--default-grid-baseline)}`, "",{"version":3,"sources":["webpack://./src/components/AppNavigation/Settings/ShortcutOverview.vue"],"names":[],"mappings":"AACA,8CACC,YAAA,CACA,gCAAA","sourcesContent":[".shortcut-section-item__keys{display:flex;gap:var(--default-grid-baseline)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
